import e from "../hooks/HookBuilder.js";
import { UnitService as r } from "../services/units.js";
const o = e.searchParamsHook(["units"], r.search, {
  errorMessage: "There was an error trying to get the units"
}), n = e.regularHook(["unit"], r.findById, {
  errorMessage: "There was an error trying to get the unit",
  disable: ([t]) => !t
}), s = e.noParamsHook(["rented-unit"], r.getRentedUnit, {
  errorMessage: "There was an error trying to get the rented unit"
}), u = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useRentedUnit: s,
  useUnit: n,
  useUnits: o
}, Symbol.toStringTag, { value: "Module" }));
export {
  u as units,
  s as useRentedUnit,
  n as useUnit,
  o as useUnits
};
//# sourceMappingURL=units-DSO5dbHv.js.map
